import { PlaceholderCard, } from "../../../shared/PlaceholderCard";

/**
 * Placeholder for the case when there are no active installments.
 */
export function OperationsEmptyBlock() {
  return (
    <PlaceholderCard
      size="md"
      description="Нет активных покупок"
    />
  );
}
